import { render, staticRenderFns } from "./DeliveryCalendar.vue?vue&type=template&id=27c66471"
import script from "./DeliveryCalendar.vue?vue&type=script&lang=js"
export * from "./DeliveryCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../florida-ecommerce/admin-dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports